// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const AdminPayoutsClient = registerClientReference(
    function() { throw new Error("Attempted to call AdminPayoutsClient() from the server but AdminPayoutsClient is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/web/src/app/(admin)/admin/payouts/admin-payouts-client.tsx",
    "AdminPayoutsClient",
);
